/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import './CardSupport.scss';
import { appCardStyle, appIconsPath, appLinkSize, appLinkStyle } from '@utils/globalConstant';
import PropTypes from 'prop-types';
import { Link } from '@core/Link';
import { useA11y } from '@context/Utils/A11y';
import Icons from '@core/Utils/Icons/Icons';
import { sanitizeRichText } from '@utils/sanitizeHtml';

export function CardSupport() {
  const [isCardOpen, setIsCardOpen] = useState(false);

  const { tA11yTranslate } = useA11y();

  const cardTitle = 'ek_global_help_hdl1';
  const text = 'ek_global_help_txt1';
  const helplineNumber = 'ek_global_help_lnk1';
  const email = 'ek_global_help_lnk2';

  const cardIconOpenAlt = tA11yTranslate('ek_global_collapsed_aria').content;
  const cardIconCloseAlt = tA11yTranslate('ek_global_expanded_aria').content;

  return (
    <div className={`${appCardStyle.DEFAULT_GRADIENT} p-16 rounded`}>
      <div
        className="d-flex justify-content-between gap-12 cursor-pointer"
        onClick={() => setIsCardOpen(!isCardOpen)}>
        <div className="d-flex align-items-center justify-content-start gap-12">
          <Icons 
              name='SUPPORT'              
              colorType='dark'
              height='24px'
            />
          <div className="pe-40">
            {tA11yTranslate(cardTitle).isHtml ? (
              <div
                className="ek-copy-sm-14-semibold"
                dangerouslySetInnerHTML={{ __html: sanitizeRichText(tA11yTranslate(cardTitle).content) }}
              />
            ) : (
              <div className="ek-copy-sm-14-semibold">{tA11yTranslate(cardTitle).content}</div>
            )}
          </div>
        </div>
        <button
          type="button"
          className="bg-transparent border-0"
          aria-label={isCardOpen ? cardIconCloseAlt : cardIconOpenAlt}
          onClick={() => setIsCardOpen(!isCardOpen)}
          aria-expanded={isCardOpen}>
            <Icons 
              name={isCardOpen ? 'ARROW_UP' : 'ARROW_DOWN'}
              alt={isCardOpen ? cardIconCloseAlt : cardIconOpenAlt}
              colorType='dark'
              height='16px'
            />
        </button>
      </div>

      {isCardOpen && (
        <>
          {tA11yTranslate(text).isHtml ? (
            <div
              className="my-12 ek-labeltext-12-medium"
              dangerouslySetInnerHTML={{ __html: sanitizeRichText(tA11yTranslate(text).content) }}
            />
          ) : (
            <div className="my-12 ek-labeltext-12-medium">{tA11yTranslate(text).content}</div>
          )}
          <Link
            label={helplineNumber}
            linkStyle={appLinkStyle.PRIMARY}
            linkSize={appLinkSize.DEFAULT}
            {...(tA11yTranslate(helplineNumber).url && { href: tA11yTranslate(helplineNumber).url })}
          />
          <Link
            label={email}
            linkStyle={`${appLinkStyle.PRIMARY} mt-12 w-100`}
            linkSize={appLinkSize.DEFAULT}
            {...(tA11yTranslate(email).url && { href: tA11yTranslate(email).url })}
          />
        </>
      )}
    </div>
  );
}

export default CardSupport;
